export default "__VITE_ASSET__Cky0D$O___"